import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TuningsService } from '../LIB/services/tunings.service';
import { NotesService } from '../LIB/services/notes.service';
import { OptionsService } from '../services/options.service';
import { TuningsTextService, TuningText } from '../LIB/services/tunings-text.service';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
})
export class HomePage implements OnInit {
  public MIDILoaded = false;
  public currentChapterIndex = 0;
  public menuVisible1 = false;
  public menuVisible2 = false;
  public menuVisible3 = false;
  public showFretboard = -1;
  public withDescriptionToggleOption = false;
  public CSValue = {note12: -1, name: '', type: ''};
  public description: boolean[] = [];
  public CS: string[] = [
    'Major chord',
    'Minor chord',
    '7 chord',
    'Minor 7 chord',
    'maj7 chord',
    'Major scale',
    'Minor scale',
    'Maj. penta. scale',
    'Min. penta. scale'
  ];
  public defaultSelectedCS = 5;
  public CSValues: {name: string, type: string}[] = [
    {name: 'major', type: 'chord'},
    {name: 'minor', type: 'chord'},
    {name: ' 7', type: 'chord'},
    {name: 'm7', type: 'chord'},
    {name: 'maj7', type: 'chord'},
    {name: 'major ', type: 'scale'},
    {name: 'minor (natural)', type: 'scale'},
    {name: 'pentatonic major', type: 'scale'},
    {name: 'pentatonic minor', type: 'scale'}
  ];
  public selectedNote12String: string;
  public selectedCSIndexString: string;
  public chapterNames: string[] = [];
  constructor(
    private route: ActivatedRoute,
    public tuningsService: TuningsService,
    public tuningsTextService: TuningsTextService,
    public notesService: NotesService,
    public opt: OptionsService,
    public platform: Platform
  ) {
    this.getTunings().forEach((foo) => {
      this.description.push(true);
    });
    this.tuningsService.chapters.forEach((chapter) => {
      this.chapterNames.push(chapter.titleEn);
    });
  }
  ngOnInit() {
    const param = this.route.snapshot.paramMap.get('id') || '0';
    this.currentChapterIndex = Number(param);
    this.displayFretboard(0);
  }
  displayMenu(menu: number) {
    this.menuVisible1 = (menu === 1);
    this.menuVisible2 = (menu === 2);
    this.menuVisible3 = (menu === 3);
  }
  toggleFretboard(tuningIndex: number) {
    if (this.showFretboard === tuningIndex) {
      this.showFretboard = -1;
    } else {
      this.displayFretboard(tuningIndex);
    }
  }
  goToChapter(chapter: number) {
    this.currentChapterIndex = chapter;
    this.displayMenu(0);
    this.displayFretboard(0);
  }
  displayFretboard(tuningIndex: number) {
    this.showFretboard = tuningIndex;
    // Init root note with tuning scale if defined
    const currentTuning = this.getTunings()[tuningIndex];
    this.selectedNote12String = '';
    this.selectedCSIndexString = '';
    if (currentTuning.hasOwnProperty('preferredNote12') &&
        (currentTuning.preferredNote12 !== -1)) {
      this.selectedNote12String = currentTuning.preferredNote12.toString();
      if (currentTuning.preferredChord === 'm') {
        this.selectedCSIndexString = '1';
      } else if (currentTuning.preferredChord === 'm7') {
        this.selectedCSIndexString = '3';
      } else if (currentTuning.preferredScale === 'major') {
        this.selectedCSIndexString = '5';
      } else if (currentTuning.preferredScale === 'minor') {
        this.selectedCSIndexString = '6';
      } else if (currentTuning.preferredScale !== 'none') {
        this.selectedCSIndexString = this.defaultSelectedCS.toString();
      }
    }
    this.refreshFretboard();
  }
  refreshFretboard() {
    if (
      (!this.selectedNote12String) ||
      (!this.selectedCSIndexString)) {
      this.CSValue = {note12: -1, name: '', type: ''};
    } else {
      this.CSValue = {
        type: this.CSValues[parseInt(this.selectedCSIndexString, 10)].type,
        name: this.CSValues[parseInt(this.selectedCSIndexString, 10)].name,
        note12: parseInt(this.selectedNote12String, 10)
      };
    }
  }
  getTunings() {
    return this.tuningsService.chapters[this.currentChapterIndex].tunings;
  }
}
